//create a generic global handler for communication errors that go unresolved.
import { GlobalSupplierNotification } from '../v6config/supplier-services';
import { information } from '../../webmodule-common/other/ui/modal-option';
import { ServiceResponseInvalid } from '../../webmodule-common/interop/webmodule-interop';
import { setCurrentUser } from '../../webmodule-common/other/api/current-user';
import { showError } from '../../webmodule-common/other/ui/show-error';
import { showValidations } from '../../webmodule-common/other/ui/modal-validationhandler';
import {
  strDuplicateLogin,
  strInvalidClientToken,
  strNetworkUnavailable,
  strUnableToConnectToV6
} from '../../webmodule-common/other/api/network-consts';
import { strInvalidBuildNumber } from '../../webmodule-common/other/api/dealer-api-communications';
import { V6OfflineCause } from '../quotes/quote-service';
import { ValidationError } from '../../webmodule-common/other/api/validation-error';
import { handleOutOfDateIntercept } from '../../webmodule-common/other/common/web-cache';
import { pageReload } from '../../webmodule-common/other/ui/resource-resolver';
import { LangApiResponseHandler } from '../../localization/scripts/api/api-response-handler-lang';

let handlingDuplicateLogin = false;

//this will typically only be things we dont want to happen not considered normal workflow
export const responseHandler = async (response: ServiceResponseInvalid | ValidationError[]) => {
  if (!Array.isArray(response)) {
    if (response.responseError?.message === strInvalidBuildNumber) {
      try {
        await handleOutOfDateIntercept(true);
      } finally {
        pageReload();
      }
      return;
    } else if (response.responseError?.message === strInvalidClientToken) {
      if (handlingDuplicateLogin) return;
      handlingDuplicateLogin = true;
      try {
        await information(LangApiResponseHandler.clientSessionInvalid());
        window.location.reload();
      } finally {
        handlingDuplicateLogin = false;
      }
      return;
    } else if (response.responseError?.message === strDuplicateLogin) {
      if (handlingDuplicateLogin) return;
      handlingDuplicateLogin = true;
      try {
        await information(LangApiResponseHandler.duplicateLogin());
        await setCurrentUser(null);
      } finally {
        handlingDuplicateLogin = false;
      }
      return;
    } else if (response.responseError?.message.startsWith(strUnableToConnectToV6)) {
      await GlobalSupplierNotification.getInstance().makeOffline(
        V6OfflineCause.Connection,
        response.responseError?.message
      );

      return;
    } else if (response.responseError?.message === 'V6 Service upgrade in progress') {
      await GlobalSupplierNotification.getInstance().makeOffline(
        V6OfflineCause.Upgrading,
        response.responseError?.message
      );
      return;
    } else if (response.responseError?.message === strNetworkUnavailable) {
      await information(LangApiResponseHandler.systemOfflineMsg(), LangApiResponseHandler.systemOfflineTitle());
      return;
    }
    const caption = response.responseTypeCaption;
    const msg = response.responseError?.message ?? '';
    const stack = response.responseError?.stackTrace ?? '';
    console.log(`ServiceResponse Error [${caption}] "${msg}" \n StackTrace:${stack}`);
    await showError(response, () => LangApiResponseHandler.serverErrorOccurred());
  } else {
    console.log('Service Response Validation Errors Returned');
    const msg: string[] = [];
    response.forEach(err => {
      const errMsg = `${err.property} -> ${err.message}`;
      msg.push(errMsg);
      console.log(errMsg);
    });
    await showValidations(msg, () => LangApiResponseHandler.validationIssuesFromServer());
  }
};
